var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M413.016,267.32C394.46,225.752,376.808,156,376.808,156H344c0,0,0,23.204,0,44  c-32,20.788-32,88-32,88h-55.816c0-36-28.184-96-44.184-96H108v136h236L413.016,267.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1",
    style: {
      fill: "#188aab"
    },
    d: "M244.184,288h12c0-36-28.184-96-44.184-96h-12C216,192,244.184,252,244.184,288z  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_2",
    style: {
      fill: "#188aab"
    },
    d: "M376.808,156h-12c0,0,17.652,69.752,36.208,111.32L332,328h12l69.016-60.68  C394.46,225.752,376.808,156,376.808,156z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#242424"
    },
    cx: 144,
    cy: 336,
    r: 36
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#cccccc"
    },
    cx: 144,
    cy: 336,
    r: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#242424"
    },
    cx: 144,
    cy: 336,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#242424"
    },
    cx: 416,
    cy: 336,
    r: 36
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#cccccc"
    },
    cx: 416,
    cy: 336,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#242424"
    },
    cx: 416,
    cy: 336,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_3",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M352,352c-16.152-29.296-10.132-61.908,16-80  c26.136-18.092,67.848-13.008,84,16.28L352,352z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_4",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M390.916,262.628c12.352,2.344,20.14,5.416,28.336,15.12  c4.752,5.62-2.836,17.916-6.704,20.38c-16.452,10.48-65.82,41.94-65.82,41.94c1.376,4.008,3.104,8,5.272,11.924l100-63.724  C440.064,266.632,414.168,258.252,390.916,262.628z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_5",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M220,328c0-40-32.648-72-68.5-72c-46.404,0-75.5,12-87.5,72H220z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_6",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M151.5,256c-3.052,0-6.024,0.056-8.924,0.172  C177.192,257.936,208,289.152,208,328h12C220,288,187.352,256,151.5,256z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_7",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M380,124c-6.58,0-25.42,0-32,0c-11.048,0-20,8.952-20,20s8.952,20,20,20  c6.58,0,25.42,0,32,0c11.048,0,12-8.952,12-20S391.048,124,380,124z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_8",
    style: {
      fill: "#f5f5f5"
    },
    d: "M380,124c-0.012,0-0.028,0-0.04,0c-2.472,5.48-3.96,12.42-3.96,20  s1.488,14.52,3.96,20c0.012,0,0.028,0,0.04,0c11.048,0,12-8.952,12-20S391.048,124,380,124z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_9",
    style: {
      fill: "#f25a23"
    },
    d: "M224,184c0,6.628-5.372,12-12,12H96c-6.628,0-12-5.372-12-12v-12  c0-6.628,5.372-12,12-12h116c6.628,0,12,5.372,12,12V184z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_10",
    style: {
      fill: "#e6e6e6"
    },
    d: "M344,148c-4.416,0-8-3.584-8-8c0-3.584-4.416-8-8-8h-28c-4.416,0-8-3.584-8-8  s3.584-8,8-8h28c12.336,0,24,11.664,24,24C352,144.416,348.416,148,344,148z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_11",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M108,220c-1.412,0-6.588,0-8,0c-6.628,0-8,5.376-8,12s1.372,12,8,12  c1.412,0,6.588,0,8,0c6.628,0,12-5.376,12-12S114.628,220,108,220z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_12",
    style: {
      fill: "#ffd464"
    },
    d: "M96,220.92c-3.216,1.812-4,6.084-4,11.08s0.784,9.264,4,11.08  c3.216-1.812,4-6.084,4-11.08S99.216,222.736,96,220.92z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M413.016,267.32C394.46,225.752,376.808,156,376.808,156H344   c0,0,0,23.204,0,44c-32,20.788-32,88-32,88h-55.816c0-36-28.184-96-44.184-96H108v136h236L413.016,267.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1_1_",
    style: {
      fill: "#188aab"
    },
    d: "M244.184,288h12c0-36-28.184-96-44.184-96h-12   C216,192,244.184,252,244.184,288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_2_1_",
    style: {
      fill: "#188aab"
    },
    d: "M376.808,156h-12c0,0,17.652,69.752,36.208,111.32L332,328h12l69.016-60.68   C394.46,225.752,376.808,156,376.808,156z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#242424"
    },
    cx: 144,
    cy: 336,
    r: 36
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#cccccc"
    },
    cx: 144,
    cy: 336,
    r: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#242424"
    },
    cx: 144,
    cy: 336,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#242424"
    },
    cx: 416,
    cy: 336,
    r: 36
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#cccccc"
    },
    cx: 416,
    cy: 336,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#242424"
    },
    cx: 416,
    cy: 336,
    r: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_3_1_",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M352,352c-16.152-29.296-10.132-61.908,16-80   c26.136-18.092,67.848-13.008,84,16.28L352,352z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_4_1_",
    style: {
      fill: "#188aab"
    },
    d: "M390.916,262.628c12.352,2.344,20.14,5.416,28.336,15.12   c4.752,5.62-2.836,17.916-6.704,20.38c-16.452,10.48-65.82,41.94-65.82,41.94c1.376,4.008,3.104,8,5.272,11.924l100-63.724   C440.064,266.632,414.168,258.252,390.916,262.628z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_5_1_",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M220,328c0-40-32.648-72-68.5-72c-46.404,0-75.5,12-87.5,72H220z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_6_1_",
    style: {
      fill: "#188aab"
    },
    d: "M151.5,256c-3.052,0-6.024,0.056-8.924,0.172   C177.192,257.936,208,289.152,208,328h12C220,288,187.352,256,151.5,256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_7_1_",
    style: {
      fill: "rgb(0, 111, 143)"
    },
    d: "M380,124c-6.58,0-25.42,0-32,0c-11.048,0-20,8.952-20,20s8.952,20,20,20   c6.58,0,25.42,0,32,0c11.048,0,12-8.952,12-20S391.048,124,380,124z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_8_1_",
    style: {
      fill: "#f5f5f5"
    },
    d: "M380,124c-0.012,0-0.028,0-0.04,0c-2.472,5.48-3.96,12.42-3.96,20   s1.488,14.52,3.96,20c0.012,0,0.028,0,0.04,0c11.048,0,12-8.952,12-20S391.048,124,380,124z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_9_1_",
    style: {
      fill: "#f25a23"
    },
    d: "M224,184c0,6.628-5.372,12-12,12H96c-6.628,0-12-5.372-12-12v-12   c0-6.628,5.372-12,12-12h116c6.628,0,12,5.372,12,12V184z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_10_1_",
    style: {
      fill: "#e6e6e6"
    },
    d: "M344,148c-4.416,0-8-3.584-8-8c0-3.584-4.416-8-8-8h-28   c-4.416,0-8-3.584-8-8s3.584-8,8-8h28c12.336,0,24,11.664,24,24C352,144.416,348.416,148,344,148z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_11_1_",
    style: {
      fill: "#188aab"
    },
    d: "M108,220c-1.412,0-6.588,0-8,0c-6.628,0-8,5.376-8,12s1.372,12,8,12   c1.412,0,6.588,0,8,0c6.628,0,12-5.376,12-12S114.628,220,108,220z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_12_1_",
    style: {
      fill: "#ffd464"
    },
    d: "M96,220.92c-3.216,1.812-4,6.084-4,11.08s0.784,9.264,4,11.08   c3.216-1.812,4-6.084,4-11.08S99.216,222.736,96,220.92z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.8bc1526702c066ea2263678d7319fc3a.svg";
export { ForwardRef as ReactComponent };